const DEFAULT_MAX_PUNCH_DISTANCE = 200;

export default DEFAULT_MAX_PUNCH_DISTANCE;
